enum EUserRole {
    All = 0,
    UserWithoutPA = 1,
    Client = 2,
    GOOwner = 3,
    TSO = 4,
    Operator = 5,
    Administrator = 6,
    SuperAdmin = 7,
}

enum EDocumentType {
    ContractMaintainRegister = 1,
    MachineReadableAttorney = 2,
}

// Словарь русскоязычных наименований полей профиля
const fieldNames: Readonly<Record<string, string>> = {
    user_role: 'Роль в системе',
    user_type: 'Тип пользователя',
    first_name: 'Имя',
    last_name: 'Фамилия',
    middle_name: 'Отчество',
    middle_name_absent: 'Нет отчества',
    bank_details: 'Банковские реквизиты',
    company_name: 'Полное название организации',
    company_name_short: 'Сокращенное название организации',
    company_inn: 'ИНН',
    ogrn: 'ОГРН',
    kpp: 'КПП',
    egrul_government_name: 'Наименование гос. органа, осуществившего регистрацию в ЕГРЮЛ',
    egrul_registration_date: 'Дата регистрации в ЕГРЮЛ',
    company_position: 'Должность',
    phone: 'Телефон / факс',
    web: 'Сайт',
    legal_address: 'Юридический адрес',
    post_address: 'Почтовый адрес',
    post_address_matches: 'Совпадает с юридическим',
    without_attorney: 'Лицо, имеющее право без доверенности действовать от имени юридического лица',
    point_delivery_codes_consuming: 'Коды ГТП потребления',
    machine_readable_attorney: 'Машиночитаемая доверенность',
    email: 'Адрес электронной почты(Email)'
} as const

// Функция для получения русскоязычных наименований полей профиля
const GetFieldName = (key: string): string => {
    return fieldNames[key] || key // Возвращаем ключ, если перевода нет
}

export { EUserRole, EDocumentType, GetFieldName }
